import {
  EXCHANGES_ADD_OR_EDIT_ADDRESS_EVENT,
  EXCHANGES_CLOSE_SELECT_ADDRESS,
  EXCHANGES_DELETE_ADDRESS,
  EXCHANGES_EDIT_ADDRESS,
  EXCHANGES_ON_CHANGE_SHIPPING_CLICK,
  EXCHANGES_ON_HIDE_NEW_SHIPPING_ADDRESS_MODAL_CLICK,
  EXCHANGES_ON_SHOW_ADD_NEW_SHIPPING_ADDRESS_MODAL_CLICK,
  EXCHANGES_ON_USE_SHIPPING_ADDRESS_CLICK,
  EXCHANGES_REQUEST_ALL_ADDRESSES,
  EXCHANGES_SAVE_ADDRESS,
  EXCHANGES_SET_PRIMARY_SHIPPING_ADDRESS,
  EXCHANGES_SET_SELECTED_SHIPPING_ADDRESS_ID,
  EXCHANGES_SET_SELECTED_SUGGESTED_ADDRESS_ID,
  EXCHANGES_USE_SUGGESTED_ADDRESS,
  EXCHANGES_VERIFY_ADDRESS_PAGEVIEW
} from 'store/ducks/exchanges/types';

export const onSetPrimaryShippingAddress = selectedAddressId => ({ type: EXCHANGES_SET_PRIMARY_SHIPPING_ADDRESS, selectedAddressId });
export const onUseShippingAddressClick = (selectedAddressId, isValid) => ({ type: EXCHANGES_ON_USE_SHIPPING_ADDRESS_CLICK, selectedAddressId, isValid });
export const onChangeShippingAddressClick = () => ({ type: EXCHANGES_ON_CHANGE_SHIPPING_CLICK });
export const onEditAddressClick = (editAddressId, editAddressIndex) => ({ type: EXCHANGES_EDIT_ADDRESS, editAddressId, editAddressIndex });
export const onUseSuggestedAddressClick = (addressType, selectedAddressId) => ({ type: EXCHANGES_USE_SUGGESTED_ADDRESS, addressType, selectedAddressId });
export const onAddOrEditAddressEvent = (passedValidation, addressId, addressType) => ({ type: EXCHANGES_ADD_OR_EDIT_ADDRESS_EVENT, passedValidation, addressId, addressType });
export const onAddOrEditShippingAddressErrorEvent = () => ({ type: EXCHANGES_ADD_OR_EDIT_ADDRESS_EVENT, passedValidation: false, addressId: null, addressType: 2 });
export const onDeleteShipAddressClick = addressId => ({ type: EXCHANGES_DELETE_ADDRESS, addressId });
export const saveShippingAddress = () => ({ type: EXCHANGES_SAVE_ADDRESS, isBilling: false });
export const onSelectedShippingAddress = selectedAddressId => ({ type: EXCHANGES_SET_SELECTED_SHIPPING_ADDRESS_ID, selectedAddressId });
export const onSelectedSuggestedShippingAddress = (selectedAddressId, selectedAddressIndex) => ({ type: EXCHANGES_SET_SELECTED_SUGGESTED_ADDRESS_ID, selectedAddressId, selectedAddressIndex });
export const requestAddresses = () => ({ type: EXCHANGES_REQUEST_ALL_ADDRESSES });
export const onHideNewShippingAddressModalClick = () => ({ type: EXCHANGES_ON_HIDE_NEW_SHIPPING_ADDRESS_MODAL_CLICK });
export const onShowAddNewShippingAddressModalClick = () => ({ type: EXCHANGES_ON_SHOW_ADD_NEW_SHIPPING_ADDRESS_MODAL_CLICK });
export const onCloseSelectShippingAddressListClick = () => ({ type: EXCHANGES_CLOSE_SELECT_ADDRESS });
export const onVerifyAddressPageView = () => ({ type: EXCHANGES_VERIFY_ADDRESS_PAGEVIEW });
